import { FC } from "react";
import { Box, Typography, CircularProgress } from "@mui/material";

type RatioChartProps = {
  value: number;
  label: string;
  avatarUrl?: string;
};

export const RatioChart: FC<RatioChartProps> = ({
  label,
  value,
  avatarUrl,
}) => {
  const displayValue = Math.round(value);

  return (
    <Box display="flex" flexDirection="column" alignItems="center">
      <Typography
        variant="subtitle2"
        sx={{
          color: "text.primary",
          fontWeight: 600,
          fontSize: "0.8rem",
          letterSpacing: "0.5px",
          mt: 2,
          mb: 1,
        }}
      >
        {label.toUpperCase()}
      </Typography>
      <Box position="relative" display="inline-flex">
        <CircularProgress
          variant="determinate"
          value={100}
          size={90}
          thickness={4.5}
          sx={{
            color: "#f0f0f0",
            position: "absolute",
          }}
          aria-label="Ratio background circle"
        />
        <CircularProgress
          variant="determinate"
          value={displayValue}
          size={90}
          thickness={4.5}
          sx={{ color: "#1ba0e9" }}
          aria-label={`Ratio value: ${displayValue}%`}
        />
        <Box
          position="absolute"
          top={0}
          left={0}
          right={0}
          bottom={0}
          display="flex"
          alignItems="center"
          justifyContent="center"
        >
          {avatarUrl ? (
            <img
              src={avatarUrl}
              alt="avatar"
              style={{
                width: "60px",
                height: "60px",
                borderRadius: "50%",
                objectFit: "cover",
              }}
            />
          ) : (
            <Typography
              variant="subtitle1"
              fontWeight={600}
              color="text.primary"
            >
              {`${displayValue}%`}
            </Typography>
          )}
        </Box>
      </Box>
      {avatarUrl && (
        <Typography variant="subtitle1" fontWeight={600} color="text.primary">
          {`${displayValue}%`}
        </Typography>
      )}
    </Box>
  );
};
